export function createMembershipDetailsStore() {
    return {
        namespaced: true,

        state: {
            /**
             * Will be a Membership if one is loaded.
             * Will be null if no membership has been loaded yet (or is in the process of loading).
             * Will be false if a membership was requested but was not found.
             *
             * @type {Membership|null|boolean}
             */
            currentMembership: null,

            /**
             * @type {MembershipSubscription|null}
             */
            currentMembershipSubscription: null,

            /**
             * @type {Member|null}
             */
            selectedMember: null,

            /**
             * @type {"members"|"visits"|"payments"|"linked-members"}
             */
            activeTabName: 'members',

            /**
             * @type {boolean}
             */
            stopRenewingInProgress: false,
        },

        mutations: {
            setCurrentMembership(state, value) {
                state.currentMembership = value;
            },

            setCurrentMembershipSubscription(state, value) {
                state.currentMembershipSubscription = value;
            },

            setSelectedMember(state, value) {
                state.selectedMember = value;
            },

            setActiveTabName(state, value) {
                state.activeTabName = value;
            },

            setStopRenewingInProgress(state, value) {
                state.stopRenewingInProgress = value;
            },
        },

        actions: {
            clear({ commit }) {
                commit('setCurrentMembership', null);
                commit('setCurrentMembershipSubscription', null);
                commit('setSelectedMember', null);
                commit('setActiveTabName', 'members');
                commit('setStopRenewingInProgress', false);
            },
        },
    };
}
